export default __webpack_public_path__ + "static/media/bear-sled.e349331c.png";